import React from 'react';

import { CaptionText, HeadingText } from '@paypalcorp/pp-react';
import styles from './benefits.less';

const ListStyle = {
  display: 'flex',
  alignItems: 'center',
  minHeight: '80px',
  marginTop: '15px',
};

const IconStyle = {
  width: '64px',
  height: '64px',
};

const ListTextStyle = {
  paddingLeft: '20px',
};

const Benefits = ({ i18n, cdnHost }) => {
  return (
    <div>
      <HeadingText as='h1' size='md' className={styles['npo-charityTitle']}>
        {i18n('label.all-to-charity')}
      </HeadingText>
      <div>
        <div style={ListStyle}>
          <img
            alt=''
            src={`https://${cdnHost}/images/Cause/ic_trust@2x.png`}
            style={IconStyle}
          />
          <div style={ListTextStyle}>
            <CaptionText strong size='md' regular>
              {i18n('label.trusted-nonprofit')}
            </CaptionText>
            <CaptionText as='p' size='md'>
              {i18n('label.vet-confirm-status')}
            </CaptionText>
          </div>
        </div>
        <div style={ListStyle}>
          <img
            alt=''
            src={`https://${cdnHost}/images/Cause/ic_fees@2x.png`}
            style={IconStyle}
          />
          <div style={ListTextStyle}>
            <CaptionText strong size='md' regular>
              {i18n('label.we-pay-fee')}
            </CaptionText>
            <CaptionText as='p' size='md'>
              {i18n('label.pp-pays-100%')}
            </CaptionText>
          </div>
        </div>
        <div style={ListStyle}>
          <img
            alt=''
            src={`https://${cdnHost}/images/Cause/ic_receipt@2x.png`}
            style={IconStyle}
          />
          <div style={ListTextStyle}>
            <CaptionText strong size='md' regular>
              {i18n('label.rcv-tax-rept')}
            </CaptionText>
            <CaptionText
              as='p'
              size='md'
              dangerouslySetInnerHTML={{
                __html: i18n('label.send-tax-receipt'),
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Benefits;
